import React, { useState, useRef } from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Story() {
  const { t } = useTranslation();

const timeline = [
  {
    title: "1999",
      description: t("story.year1999"),
  },
  {
    title: "2003",
      description: t("story.year2003"),
  },
  {
    title: "2007",
      description: t("story.year2007"),
  },
  {
    title: "2010",
      description: t("story.year2010"),
  },
  {
    title: "2014",
      description: t("story.year2014"),
  },
  {
    title: "2018",
      description: t("story.year2018"),
  },
  {
    title: "2021",
      description: t("story.year2021"),
  },
  {
    title: "2023",
      description: t("story.year2023"),
  },
  {
    title: "2025",
      description: t("story.year2025"),
  },
];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const dragStartY = useRef(0);
  const dragOffset = useRef(0);

  const [titleRef, titleVisible] = useScrollAnimation();
  const [timelineRef, timelineVisible] = useScrollAnimation();

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % timeline.length);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 400);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev - 1 + timeline.length) % timeline.length);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 400);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragStartY.current = e.pageY || e.touches?.[0]?.pageY;
    dragOffset.current = 0;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const currentY = e.pageY || e.touches?.[0]?.pageY;
    dragOffset.current = currentY - dragStartY.current;
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);

    if (dragOffset.current > 50) {
      prevSlide();
    } else if (dragOffset.current < -50) {
      nextSlide();
    }
    dragOffset.current = 0;
  };

  const getItemPosition = (index) => {
    const diff = index - currentSlide;
    const total = timeline.length;
    const normalizedDiff = ((diff % total) + total) % total;

    // Map positions: 0 (main), 1 (next)
    if (normalizedDiff === 0) return "main-item";
    if (normalizedDiff === 1) return "next-item";
    return "hidden-item";
  };

  const getVisibleItems = () => {
    return timeline.map((item, index) => ({
      index,
      item,
      className: getItemPosition(index),
    }));
  };

  return (
    <div className="story-wrapper">
      <div className="story container">
        <div
          ref={timelineRef}
          className={`story-timeline flex ${
            timelineVisible ? "animate-in" : ""
          }`}
        >
          <div
            className="story-timeline-slider"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleMouseDown}
            onTouchMove={handleMouseMove}
            onTouchEnd={handleMouseUp}
            style={{ cursor: isDragging ? "grabbing" : "grab" }}
          >
            {getVisibleItems().map((timelineItem, idx) => (
              <div
                key={`${timelineItem.index}-${idx}`}
                className={`story-timeline-item flex ${timelineItem.className}`}
              >
                <h2 className="fs-1000 clr-white">{timelineItem.item.title}</h2>
                <p className="fs-500 clr-white">
                  {timelineItem.item.description}
                </p>
              </div>
            ))}
          </div>
          <div className="story-timeline-arrows">
            <button
              className="story-timeline-arrow-up"
              onClick={prevSlide}
              style={{ cursor: "pointer" }}
            >
              <img src="/assets/icons/arrowUpWhite.svg" alt="Arrow Up" />
            </button>
            <button
              className="story-timeline-arrow-down"
              onClick={nextSlide}
              style={{ cursor: "pointer" }}
            >
              <img src="/assets/icons/arrowDownWhite.svg" alt="Arrow Down" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Story;
